import React from 'react';
// import { useFullscreen } from 'react-use';
import watermarkImg from '../../assets/images/dev.png'; // added image import

export default function EnvironmentWatermark() {
  const env = (
    process.env.REACT_APP_ENV ||
    process.env.NODE_ENV ||
    ''
  ).toLowerCase();
  const isDev =
    env === 'development' || env === 'dev' || env === 'test' || env === 'tst';
  if (!isDev) return null;
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        backgroundImage: `url(${watermarkImg})`, // Corrected line
        backgroundRepeat: 'repeat',
        backgroundSize: '1200px 1200px',
        opacity: 3.0,
        mixBlendMode: 'multiply',
      }}
    />
  );
}
